import { createClient } from '@supabase/supabase-js'

const url = process.env.VUE_APP_SUPABASE_URL
const anonKey = process.env.VUE_APP_SUPABASE_ANON_KEY

let client = null

export function isBrowserAuthConfigured() {
  return Boolean(url && anonKey)
}

export function getSupabase() {
  if (!isBrowserAuthConfigured()) {
    throw new Error('Supabase is not configured. Set VUE_APP_SUPABASE_URL and VUE_APP_SUPABASE_ANON_KEY.')
  }
  if (!client) {
    client = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  }
  return client
}

export function getAuthRedirectUrl() {
  return process.env.VUE_APP_AUTH_REDIRECT || `${window.location.origin}/auth/callback`
}
